import { type FC } from "react";
import { TelButton } from "@legacy_user_frontend/components/projects/button_contents/src/tel_button";
import {
  ScoutButton,
  type ScoutButtonProps,
} from "@legacy_user_frontend/components/projects/button_contents/src/scout_button";
import {
  entryButton,
  fixBtnList,
  fixTelButtonOuter,
  fixEntryButtonOuter,
  fixTelBtn,
} from "@legacy_user_frontend/components/projects/button_contents/src/styles.css";
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
declare const $: any;

type FixButtonProps = {
  scoutButtonContent: ScoutButtonProps["scoutButtonContent"];
  entryButtonContent: {
    isEnterable: boolean;
    hasEntried: boolean;
    entryUrl: string;
  };
  telNumberContent: {
    isShowTellButton: boolean;
    telNumber: string;
  };
  gaLabel: string;
  queryStr: string;
  workCode: string;
  scoutGaLabel: string;
  clientShopId: number | string;
  pageType: string;
  capitalizePageType: string;
  isApp: boolean;
  dataStyleColumn: number;
  isPreview: boolean;
};

export const FixButton: FC<FixButtonProps> = ({
  scoutButtonContent,
  entryButtonContent: { isEnterable, hasEntried, entryUrl },
  telNumberContent,
  gaLabel,
  queryStr,
  workCode,
  scoutGaLabel,
  clientShopId,
  pageType,
  capitalizePageType,
  isApp,
  dataStyleColumn,
  isPreview,
}) => {
  const { isScouted } = scoutButtonContent;
  const { isShowTellButton, telNumber } = telNumberContent;
  // 電話応募ボタンクリック時にクリックされた求人情報を送信
  const handleOnClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    $.fn.sendTelButtonAction({
      code: workCode,
      client_shop_id: clientShopId,
    });
  };
  return (
    <>
      {workCode && (
        <div className={`${fixBtnList} js-footer-fix__btn`}>
          {!isScouted && isEnterable && (
            <>
              {isShowTellButton && (
                <div className={fixTelButtonOuter}>
                  <TelButton
                    telNumber={telNumber}
                    position="fixed"
                    clientShopId={clientShopId}
                    gaLabel={gaLabel}
                    pageType={pageType}
                    capitalizePageType={capitalizePageType}
                    workCode={workCode}
                    isPreview={isPreview}
                  />
                </div>
              )}
              <div className={fixEntryButtonOuter({ is2column: isShowTellButton })}>
                <a
                  href={entryUrl}
                  className={`${entryButton({ isFixed: true })} ga-click firebase-click disable-on-preview js-add-query-strings`}
                  data-ga-action={`${pageType}_entry-fixed`}
                  data-ga-label={gaLabel}
                  data-firebase-action="entry"
                  data-firebase-view-type="screen_view"
                  data-query-str={queryStr}
                >
                  応募画面へ進む
                </a>
              </div>
            </>
          )}
          {isScouted && (
            <ScoutButton
              scoutButtonContent={scoutButtonContent}
              scoutGaLabel={scoutGaLabel}
              hasEntried={hasEntried}
              workCode={workCode}
              position="fixed"
              isFixedButton
              pageType={pageType}
              isApp={isApp}
              dataStyleColumn={dataStyleColumn}
            />
          )}
        </div>
      )}
      {!workCode && isShowTellButton && (
        <div className={`${fixBtnList} js-footer-fix__btn`}>
          <a
            href={`tel:${telNumber}`}
            className={`${fixTelBtn} ga-click disable-on-preview`}
            data-ga-action={`${pageType}_entry_tel-fixed`}
            data-ga-label={gaLabel}
            data-client-shop-id={clientShopId}
            onClick={handleOnClick}
          >
            <b>
              <i className="icon-phone" />
              電話で応募する
            </b>
          </a>
        </div>
      )}
    </>
  );
};
